import { JSX, useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

interface DataManagementMapboxProps {
    address: {
        lat: number;
        long: number;
    };
}

export const DataManagementMapbox = ({
    address,
}: DataManagementMapboxProps): JSX.Element => {
    const mapContainerRef = useRef(null);

    useEffect(() => {
        if (mapContainerRef.current) {
            const map = new mapboxgl.Map({
                accessToken: import.meta.env.VITE_MAPBOX_ACCESS_TOKEN,
                container: mapContainerRef.current,
                style: "mapbox://styles/idotwebengineers/cm4vcfbui001x01sbcvbwa6mw",
                center: [address.long, address.lat],
                zoom: 16,
            });

            const markerElement = document.createElement("div");
            markerElement.className = "custom-marker";

            new mapboxgl.Marker(markerElement)
                .setLngLat([address.long, address.lat])
                .addTo(map);

            return () => map.remove();
        }
    }, [address]);

    return (
        <div
            className="p-show-establishment-details__content__mapbox"
            ref={mapContainerRef}
            style={{ height: "20rem" }}
        ></div>
    );
};
